import { useCallback } from 'react';
import { StyledAutoFlowGrid } from '~/app/pages/components/styled-auto-flow-grid';
import { gridAreas } from './config';
import { AutoFlowGridProps } from './types';
import { htmlToText } from 'html-to-text';

export const AutoFlowGrid = ({ direction, sources }: AutoFlowGridProps) => {
	const renderSources = useCallback(() => {
		return sources
			.filter(Boolean)
			.filter(({ src }) => Boolean(src))
			.map(({ src, alt }, index) => {
				return (
					<img
						className="border-radius-md"
						key={src}
						src={src}
						alt={htmlToText(alt)}
						style={{
							gridArea: gridAreas[direction].itemAreas[index],
							aspectRatio: gridAreas[direction].aspectRatios[index],
						}}
					/>
				);
			});
	}, [JSON.stringify(sources)]);

	return <StyledAutoFlowGrid $direction={direction}>{renderSources()}</StyledAutoFlowGrid>;
};
